// Formats a PostgREST `last_sent_at` timestamp (UTC-cast, e.g. "2026-07-18T14:32:00") into the
// browser's locale date string. `toLocaleDateString()` is called with no locale/options argument
// so it uses the runtime's own locale (the "per browser i18n" requirement) — MM/DD/YY on en-US.
// Returns null for missing/invalid input so callers can render nothing rather than a bad date.
export default function formatLastMessageDate(lastSentAt) {
  if (!lastSentAt) return null;

  const date = new Date(lastSentAt);
  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleDateString();
}
